<template>
<v-autocomplete
  v-model="storeParty"
  :items="userStoreParties"
  background-color="input"
  class="ma-0"
  dense
  item-text="store_name"
  item-id="store_party_id"
  label="Store Group / Store"
  :menu-props="{ maxHeight: 300 }"
  outlined
  return-object
  hide-details
  @change="updateStoreGroup">
</v-autocomplete>
</template>

<script>
import { userAccess } from '@/mixins/user-access'
import { displayAlert } from '@/mixins/alert'
export default {
  name: 'StorePartiesDropdown',
  props: {
    userStoreParties: Array
  },
  mixins: [userAccess, displayAlert],
  data() {
    return {
      storeParty: {}
    }
  },
  watch: {
    userStoreParties: {
      handler(newValue) {
        if (newValue?.length > 0) {
          const stored = sessionStorage.tpr_pro_store_group ? JSON.parse(sessionStorage.tpr_pro_store_group) : null
          this.storeParty = stored?.store_party_id ? stored : this.userStoreParties.find(p => p.store_party_id)
          this.$emit('updateStoreParty', this.storeParty)
        }
      }
    }
  },
  methods: {
    updateStoreGroup() {
      sessionStorage.setItem('tpr_pro_store_group', JSON.stringify(this.storeParty))
      this.$emit('updateStoreParty', this.storeParty)
    }
  }
}
</script>
<style>
div.v-subheader.theme--light {
  font-weight: bold !important;
  color: black !important;
  font-size: medium !important;
}
</style>